// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"6d2e6252","581":"4547af70"}[chunkId] + ".chunk.js";
};